import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import Template from "./booking-state-selection.html";
import Controller from "./booking-state-selection.controller";
import BookingStateSelectionModal from "./booking-state-selection.modal";

let BookingStateSelectionModule = Angular.module('booking-state-selection', []);

BookingStateSelectionModule.component('bookingStateSelection', {
    template: Template,
    controller: Controller,
    bindings: {
        selectedState: '<',
        onStateSelected: '&'
    },
});

new Loader(BookingStateSelectionModule)
    .load(BookingStateSelectionModal);

export default BookingStateSelectionModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-state-selection/booking-state-selection.js